import type { CancelTokenSource } from 'axios';
import { SILENT_ERROR } from '../../../../_util/types';

interface RequestInFlight {
  id: number;
  url: string;
  data: Record<string, unknown>;
  method: string;
  cancelSource: CancelTokenSource;
}

interface AddRequestProps {
  id: number;
  url: string;
  data: Record<string, unknown>;
  method: string;
  cancelSource: CancelTokenSource;
}

interface CancelRequestProps {
  cancelEarlierRequests?: boolean;
  id?: number;
  url?: string;
  method?: string;
  data?: Record<string, unknown>;
  [key: string]: unknown;
}

let requestsInFlight: RequestInFlight[] = [];

export const addRequestInFlight = (props: AddRequestProps): void => {
  const newRequest: RequestInFlight = {
    id: props.id,
    url: props.url,
    data: props.data,
    method: props.method,
    cancelSource: props.cancelSource,
  };

  requestsInFlight = [...requestsInFlight, newRequest];
};

export const removeRequestInFlight = ({ id }: { id?: number }): void => {
  requestsInFlight = requestsInFlight.filter((request) => request.id !== id);
};

export const cancelEarlierRequests = (currentRequest: CancelRequestProps): void => {
  const { cancelEarlierRequests = false } = currentRequest;

  if (cancelEarlierRequests) {
    const requestsToCancel = requestsInFlight.filter((requestInFlight) => {
      const fieldsToCompare = ['id', 'url', 'method', 'data'] as const;

      const isMatch = fieldsToCompare.every((field) => {
        const currentRequestValue = currentRequest[field];
        const requestInFlightValue = requestInFlight[field];

        switch (field) {
          case 'id':
            return currentRequestValue !== requestInFlightValue;

          case 'data': {
            const currentData = currentRequestValue as Record<string, unknown>;
            const flightData = requestInFlightValue as Record<string, unknown>;
            const isApiKeyMatch = currentData.key === flightData.key;

            if (isApiKeyMatch) {
              const currentDataKeys = Object.keys(currentData);
              const requestDataKeys = Object.keys(flightData);
              const isSameLength = currentDataKeys.length === requestDataKeys.length;

              if (isSameLength) {
                const areSameKeys = currentDataKeys.every((key) => requestDataKeys.includes(key));
                return areSameKeys;
              }

              return false;
            }

            return false;
          }
          default:
            return currentRequestValue === requestInFlightValue;
        }
      });

      return isMatch;
    });

    requestsToCancel.forEach(({ cancelSource }) => {
      cancelSource.cancel(SILENT_ERROR);
    });
  }
};
